import { NavLink } from "react-router-dom";

const NAV_ITEMS = [
  { label: "Explore", path: "explore", icon: "◎" },
  { label: "Analysis", path: "analysis", icon: "◈" },
  { label: "Search", path: "search", icon: "⌕" },
  { label: "Architecture", path: "architecture", icon: "⬡" },
];

export function AppSidebar({ projectId, repoId }: { projectId: string; repoId: string }) {
  const base = `/projects/${projectId}/repos/${repoId}`;
  return (
    <nav className="sidebar" aria-label="Repository navigation">
      <div className="sidebar-header">
        <span className="sidebar-repo-label">Repository</span>
      </div>
      <ul className="sidebar-nav">
        {NAV_ITEMS.map(({ label, path, icon }) => (
          <li key={path}>
            <NavLink
              to={`${base}/${path}`}
              className={({ isActive }) => `sidebar-link${isActive ? " active" : ""}`}
            >
              <span className="sidebar-icon">{icon}</span>
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="sidebar-footer">
        <NavLink to="/projects" className="sidebar-back-link">
          ← All projects
        </NavLink>
      </div>
    </nav>
  );
}
